webpackJsonp([255],{

/***/ 1258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDetail_vue__ = __webpack_require__(3005);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4afcda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDetail_vue__ = __webpack_require__(5518);
function injectStyle (ssrContext) {
  __webpack_require__(5512)
  __webpack_require__(5514)
  this["$style"] = __webpack_require__(5516)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d4afcda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4afcda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      taskid: null,
      data: {},
      table: [{
        key: 'taskid',
        label: '任务ID',
        value: ''
      }, {
        key: 'strstatus',
        label: '任务状态',
        value: ''
      }, {
        key: 'cacheuploadstatus',
        label: '任务缓存状态',
        value: ''
      }, {
        key: 'title',
        label: '任务标题',
        value: ''
      }, {
        key: 'strtype',
        label: '任务类型',
        value: ''
      }, {
        key: 'taskmarketareaid',
        label: '任务区域',
        value: ''
      }, {
        key: 'salary',
        label: '赏金',
        value: ''
      }, {
        key: 'managementfee',
        label: '管理费',
        value: ''
      }, {
        key: 'points',
        label: '积分',
        value: ''
      }, {
        key: 'validcheckindistance',
        label: '有效签到距离',
        value: ''
      }, {
        key: 'showtime',
        label: '任务预览开始时间',
        value: ''
      }, {
        key: 'starttime',
        label: '任务上线时间',
        value: ''
      }, {
        key: 'deadline',
        label: '任务下线时间',
        value: ''
      }, {
        key: 'taskendtime',
        label: '任务结束时间',
        value: ''
      }, {
        key: 'endtime',
        label: '用户最晚完成时间',
        value: ''
      }, {
        key: 'processingtime',
        label: '任务最晚完成时间限制(小时)',
        value: ''
      }, {
        key: 'reviewtime',
        label: '审核时间(天)',
        value: ''
      }, {
        key: 'availableTime',
        label: '任务可执行时间',
        value: ''
      }, {
        key: 'clientversion',
        label: '用户App版本',
        value: ''
      }, {
        key: 'clientosversion',
        label: '用户手机OS版本',
        value: ''
      }, {
        key: 'clientmodel',
        label: '用户手机型号',
        value: ''
      }, {
        key: 'devicenum',
        label: '用户设备号',
        value: ''
      }, {
        key: 'uservietime',
        label: '用户抢单时间',
        value: ''
      }, {
        key: 'userstarttime',
        label: '用户开始时间',
        value: ''
      }, {
        key: 'userfinishtime',
        label: '用户完成时间',
        value: ''
      }, {
        key: 'content',
        label: '任务详细描述',
        value: ''
      }, {
        key: 'seriestasktemplateid',
        label: '系列任务模板ID',
        value: ''
      }, {
        key: 'templateid',
        label: '任务模板ID',
        value: ''
      }, {
        key: 'customername',
        label: '客户编号',
        value: ''
      }, {
        key: 'projectname',
        label: '项目编号',
        value: ''
      }, {
        key: 'batchname',
        label: '批次编号',
        value: ''
      }, {
        key: 'gpsCheck',
        label: '任务提交是否验证GPS位置',
        value: ''
      }, {
        key: 'priority',
        label: '任务是否置顶',
        value: ''
      }, {
        key: 'superuserprior',
        label: '是否金牌人员优先',
        value: ''
      }, {
        key: 'onlynearby',
        label: '是否不在任务大厅显示',
        value: ''
      }, {
        key: 'multitimes',
        label: '是否准许多次接单',
        value: ''
      }, {
        key: 'rejectuserrepeat',
        label: '审核不通过时用户是否可重复执行',
        value: ''
      }, {
        key: 'dynamic_adjust_salary',
        label: '过程中调价',
        value: ''
      }, {
        key: 'allow_coupon',
        label: '允许使用优惠券',
        value: ''
      }, {
        key: 'use_servercache',
        label: '服务器缓存',
        value: ''
      }, {
        key: 'ostype',
        label: '发布平台',
        value: ''
      }, {
        key: 'platformtype',
        label: '发布App',
        value: ''
      }, {
        key: 'minclientversionforandroid',
        label: '爱零工安卓客户端最低版本',
        value: ''
      }, {
        key: 'minclientversionforios',
        label: '爱零工IOS客户端最低版本',
        value: ''
      }, {
        key: 'minclientversionforandroid_clb',
        label: '查理宝安卓客户端最低版本',
        value: ''
      }, {
        key: 'minclientversionforios_clb',
        label: '查理宝IOS客户端最低版本',
        value: ''
      }, {
        key: 'marketname',
        label: '任务所属商场',
        value: ''
      }, {
        key: 'provincename',
        label: '任务城市',
        value: ''
      }, {
        key: 'address',
        label: '门店地址',
        value: ''
      }, {
        key: 'marketinfo',
        label: '任务位置',
        value: ''
      }, {
        key: 'hirenum',
        label: '需要人数',
        value: ''
      }, {
        key: 'blackList',
        label: '黑名单',
        value: ''
      }, {
        key: 'blackListTags',
        label: '黑名单标签',
        value: ''
      }, {
        key: 'whiteList',
        label: '白名单',
        value: ''
      }, {
        key: 'whiteListTags',
        label: '白名单标签',
        value: ''
      }, {
        key: 'photo',
        label: '任务照片',
        value: ''
      }, {
        key: 'adminname',
        label: '添加管理员',
        value: ''
      }, {
        key: 'is_group_task',
        label: '是否为群组任务',
        value: ''
      }, {
        key: 'task_group_status',
        label: '群组任务开启状态',
        value: ''
      }, {
        key: 'need_full_workinfo',
        label: '限已完善职业信息用户抢单',
        value: ''
      }, {
        key: 'userprocesslog',
        label: '用户操作日志',
        value: ''
      }, {
        key: 'adminprocesslog',
        label: '管理员操作日志',
        value: ''
      }, {
        key: 'templatejson',
        label: '模板任务完成情况',
        value: ''
      }, {
        key: 'checkinlocation',
        label: '任务签到GPS位置',
        value: ''
      }, {
        key: 'finishlocation',
        label: '任务完成后GPS位置',
        value: ''
      }, {
        key: 'userid',
        label: '任务完成人',
        value: ''
      }, {
        key: 'errormessage',
        label: '审核不通过原因',
        value: ''
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), {
    templateTitle: function templateTitle() {
      if (this.data.templatejson === null) {
        return '';
      } else if (typeof this.data.templatejson === 'string') {
        return JSON.parse(this.data.templatejson).title;
      }
      return this.data.templatejson.title;
    }
  }),
  created: function created() {
    this.taskid = this.$route.params.taskid;
    this.taskid > 0 && this.setDetailData(this.taskid);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    setDetailData: function setDetailData(id) {
      var _this = this;

      request.page('getTaskDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this.data = data;
        if (_this.data.userinfo) {
          _this.data.clientversion = _this.data.userinfo.clientversion;
          _this.data.clientmodel = _this.data.userinfo.clientmodel;
          _this.data.devicenum = _this.data.userinfo.devicenum;
        } else {
          _this.data.clientversion = '';
          _this.data.clientmodel = '';
          _this.data.devicenum = '';
        }
        _this.table.forEach(function (obj) {
          if (data.hasOwnProperty(obj.key)) {
            obj.value = data[obj.key];
          }
        });
        if (data.hasOwnProperty('is_group_task') && data.is_group_task === false) {
          for (var i in _this.table) {
            if (_this.table.hasOwnProperty(i) && _this.table[i].key === 'task_group_status') {
              _this.table.splice(i, 1);
              break;
            }
          }
        }
        // 门店任务 显示门店地址
        if (data.hasOwnProperty('marketid') && data.marketid === 0) {
          _this.table = _this.table.filter(function (item) {
            return item.key !== 'address';
          });
        }
      });
    },
    ifSelect: function ifSelect(scope) {
      var item = ['cacheuploadstatus', 'taskmarketareaid', 'gpsCheck', 'priority', 'superuserprior', 'multitimes', 'rejectuserrepeat', 'rejecttaskrepeat', 'allow_coupon', 'use_servercache', 'ostype', 'onlynearby'];
      for (var i = 0; i < item.length; i++) {
        if (scope.row.key === item[i]) {
          return true;
        }
      }
      return false;
    },
    formatUnix: function formatUnix(time) {
      return filter.formatUnix(time);
    },
    salaryValue: function salaryValue(value) {
      return filter.hasPermission(250) ? value : '*';
    },
    platformtypeLabel: function platformtypeLabel(v) {
      var m = {
        0: '爱零工',
        8: '查理宝',
        9: '全选',
        1: '查理宝(旧)',
        2: '标注任务',
        3: 'Teke',
        6: '中台任务',
        7: 'DataCapture'
      };
      var n = Number(v);
      return m[n] !== undefined ? m[n] : v === '' || v === null ? '' : String(v);
    }
  })
});

/***/ }),

/***/ 5512:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5513);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("03a4353a", content, true, {});

/***/ }),

/***/ 5513:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TaskDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5514:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5515);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("15f48622", content, true, {});

/***/ }),

/***/ 5515:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "a[data-v-5d4afcda]{text-decoration:none}.blue-color[data-v-5d4afcda]{color:#589df8}", "", {"version":3,"sources":["/workspace/src/views/task/pages/TaskDetail.vue"],"names":[],"mappings":"AACA,mBAAmB,oBAAoB,CACtC,AACD,6BAA6B,aAAa,CACzC","file":"TaskDetail.vue","sourcesContent":["\na[data-v-5d4afcda]{text-decoration:none\n}\n.blue-color[data-v-5d4afcda]{color:#589df8\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5517);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("dae027a6", content, true, {});

/***/ }),

/***/ 5517:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TaskDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/task/table"}},[_vm._v("任务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":24}},[_c('layout-panel',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-table',{staticClass:"margin b15",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","show-header":false}},[_c('el-table-column',{attrs:{"width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.ifSelect(scope))?_c('span',_vm._l((_vm.options[scope.row.key]),function(item){return (scope.row.value === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()}),0):(scope.row.key === 'platformtype')?_c('span',[_vm._v("\n              "+_vm._s(_vm.platformtypeLabel(scope.row.value))+"\n            ")]):(scope.row.key === 'salary')?_c('span',[_vm._v("\n            "+_vm._s(_vm.salaryValue(scope.row.value))+"元\n            ")]):(scope.row.key === 'managementfee' )?_c('span',[_vm._v("\n            "+_vm._s(scope.row.value)+"元\n            ")]):(scope.row.key === 'points')?_c('span',[_vm._v("\n            "+_vm._s(scope.row.value)+"零豆\n            ")]):(scope.row.key === 'validcheckindistance')?_c('span',[_vm._v("\n            "+_vm._s(scope.row.value)+"公里\n            ")]):(scope.row.key === 'taskid')?_c('span',[_vm._v("\n            TSK"+_vm._s(scope.row.value)+"\n            ")]):(scope.row.key === 'templateid')?[(_vm.data.templateid !== '0')?_c('router-link',{attrs:{"to":'/step-template/update/'+_vm.data.templateid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.templateTitle)+"/"+_vm._s(scope.row.value))])]):_vm._e()]:(scope.row.key === 'customername')?_c('span',[_c('router-link',{attrs:{"to":'/task/table?customerid='+_vm.data.customerid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.data.customername))])])],1):(scope.row.key === 'projectname')?_c('span',[_c('router-link',{attrs:{"to":'/task/table?projectid='+_vm.data.projectid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.data.projectname))])])],1):(scope.row.key === 'batchname')?_c('span',[_c('router-link',{attrs:{"to":'/task/table?batchid='+_vm.data.batchid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.data.batchname))])])],1):(scope.row.key === 'marketname')?_c('span',[_c('span',[_vm._v(_vm._s(_vm.data.marketname)+"/"+_vm._s(_vm.data.marketid))])]):(scope.row.key === 'provincename')?_c('span',[_c('span',[_vm._v("\n              "+_vm._s(_vm.data.provincename)+_vm._s(_vm.data.cityname)+_vm._s(_vm.data.areaname))])]):(scope.row.key === 'marketinfo')?_c('span',[_c('span',[_vm._v(_vm._s(_vm.data.latitude)+","+_vm._s(_vm.data.longitude))]),_c('br')]):(scope.row.key === 'address' && _vm.data.marketid > 0)?_c('span',[(_vm.data.marketinfo && _vm.data.marketinfo.address)?_c('span',[_vm._v(_vm._s(_vm.data.marketinfo.address))]):_vm._e(),_c('br')]):(scope.row.key === 'hirenum')?_c('span',[_c('span',[_vm._v(_vm._s(scope.row.value)+"人")])]):(scope.row.key === 'blackList' || scope.row.key === 'whiteList')?_c('span',_vm._l((scope.row.value),function(item){return _c('span',{staticClass:"blue-color"},[_c('router-link',{attrs:{"to":'/users/detail/info?userid='+item.userid}},[(item.nickname)?_c('span',[_vm._v(_vm._s(item.nickname))]):_vm._e(),_vm._v(" "),(item.realname)?_c('span',[_vm._v("/"+_vm._s(item.realname))]):_vm._e(),_vm._v(" "),(item.cellphone)?_c('span',[_vm._v("/"+_vm._s(item.cellphone))]):_vm._e(),_c('br')])],1)}),0):(scope.row.key === 'blackListTags' || scope.row.key === 'whiteListTags')?_c('span',_vm._l((scope.row.value),function(item){return _c('span',[_vm._v("\n              "+_vm._s(item.tagname)+"/"+_vm._s(item.id)),_c('br')])}),0):(scope.row.key === 'photo')?_c('span',_vm._l((scope.row.value),function(item){return _c('span',[_c('el-image',{staticStyle:{"width":"100px","cursor":"pointer"},attrs:{"src":item,"preview-src-list":scope.row.value,"alt":"爱零工"}})],1)}),0):(scope.row.key === 'adminname')?_c('span',[_c('span',[_vm._v(_vm._s(_vm.data.adminname)+"("+_vm._s(_vm.data.adminid)+")")])]):(scope.row.key === 'is_group_task')?_c('span',[_vm._v(_vm._s(_vm.data.is_group_task ? '是' : '否'))]):(scope.row.key === 'task_group_status')?_c('span',[_vm._v(_vm._s(_vm.data.task_group_status ? '开启' : '关闭'))]):(scope.row.key === 'need_full_workinfo')?_c('span',[_vm._v(_vm._s(_vm.data.need_full_workinfo > 0 ? '是' : '否'))]):(scope.row.key === 'userprocesslog')?_c('span',[(scope.row.value)?_c('span',_vm._l((JSON.parse(scope.row.value)),function(item){return _c('span',[_c('span',[_vm._v(_vm._s(_vm.formatUnix(item.timestamp))+"\n                用户\n                "),_c('router-link',{attrs:{"to":'/users/detail/info?userid='+item.userid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(item.userid))])]),_vm._v(_vm._s(item.action)+"\n              ")],1),_c('br')])}),0):_vm._e()]):(scope.row.key === 'adminprocesslog')?_c('span',[(scope.row.value)?_c('span',_vm._l((JSON.parse(scope.row.value)),function(item){return _c('span',[_c('span',[_vm._v(_vm._s(_vm.formatUnix(item.timestamp))+"\n              "+_vm._s(item.adminname)+" "+_vm._s(item.action))]),_c('br')])}),0):_vm._e()]):(scope.row.key === 'templatejson')?_c('span',[_vm._v("\n            "+_vm._s(_vm.data.title)+"\n              ")]):(scope.row.key === 'checkinlocation')?_c('span',[_vm._v("\n            "+_vm._s(_vm.data.checkinlocation)+" (距离商场："+_vm._s(_vm.data.checkindistance)+"米)\n            ")]):(scope.row.key === 'finishlocation')?_c('span',[_vm._v("\n            "+_vm._s(_vm.data.finishlocation)+" (距离商场："+_vm._s(_vm.data.finishdistance)+"米)\n            ")]):(scope.row.key === 'userid')?_c('span',[(scope.row .value !== 0)?_c('span',[_c('router-link',{attrs:{"to":'/users/table?keyword='+_vm.data.userid}},[(_vm.data.userinfo && _vm.data.userinfo.cellphone)?_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.data.userinfo.cellphone)+"/")]):_vm._e(),_vm._v(_vm._s(_vm.data.userid)+"\n              ")])],1):_vm._e()]):(scope.row.key === 'content')?_c('span',[_c('span',{domProps:{"innerHTML":_vm._s(scope.row.value)}})]):(scope.row.key === 'availableTime')?_vm._l((scope.row.value),function(availableTime){return _c('p',[_vm._v("\n              "+_vm._s(availableTime.starttime)+" - "+_vm._s(availableTime.endtime)+"\n            ")])}):_c('span',[_vm._v(_vm._s(scope.row.value))])]}}])})],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/task/table"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("返回\n        ")])],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/task-detail.a569b778d0f503a4dbd3.js